import type { IconProps } from './icons.types';

export function ListIcon({ size = 18 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <line x1="3" y1="4.5" x2="15" y2="4.5" />
      <line x1="3" y1="9" x2="15" y2="9" />
      <line x1="3" y1="13.5" x2="15" y2="13.5" />
    </svg>
  );
}
